const message = {
  en:
    'Opens in a new window. In the case of an external site, it may or may not meet accessibility guidelines.',
  ja:
    '別ウィンドウで開きます。外部サイトの場合はアクセシビリティガイドラインに対応していない可能性があります。',
  'ko-kr': '새 창에서 엽니다. 외부 사이트인 경우, 접근성 가이드라인에 대응하지 않을 수 있습니다.',
  'zh-CN': '在新窗口打开。如是外部网站，可能会没有无障碍指南。',
  'zh-TW': '在新視窗開啟。外部網站可能不符合無障礙規範所訂定之標準。',
  de:
    'Wird in einem neuen Fenster geöffnet. Im Falle einer externen Website kann es sein, dass diese nicht die Zugangsrichtlinien erfüllt.',
  fr:
    "S'ouvre dans une nouvelle fenêtre. S'il s'agit d'un site externe, il se peut qu'il réponde ou non aux lignes directrices en matière d'accessibilité.",
  th: 'เปิดหน้าต่างใหม่ กรณีที่เข้าสู่ไซต์ภายนอก ไซต์อาจไม่เป็นไปตามหลักเกณฑ์การเข้าถึง',
  id:
    'Terbuka di jendela baru. Pada kasus situs eksternal, kemungkinan pedoman aksesibilitas tidak dapat terpenuhi.',
  'zh-HK': '在新視窗開啟。如果是外部網站，有可能不符合輔助使用的指引。',
  vi:
    'Mở trong một cửa sổ mới. Trong trường hợp mở trang web bên ngoài, trang web đó có thể đáp ứng hoặc không đáp ứng các quy tắc về truy cập.',
  default:
    'Opens in a new window. In the case of an external site, it may or may not meet accessibility guidelines.',
};

export default class ExternalLink {
  constructor(options) {
    const defaultOptions = {
      selector: '.js-external-link',
    };

    this.options = Object.assign(defaultOptions, options);

    Object.keys(this.options).forEach(key => {
      this[key] = this.options[key];
    });
  }

  init() {
    this.setARIALabel();
  }

  setARIALabel() {
    let lang = document.getElementsByTagName('html')[0].getAttribute('lang');
    const selector = document.querySelectorAll(this.options.selector);
    if (!message[lang]) {
      lang = 'default';
    }

    Array.from(selector).forEach(item => {
      item.setAttribute('aria-label', message[lang]);
    });
  }
}
